function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import md5 from "blueimp-md5";
import { useVuelidate } from "@vuelidate/core";
import { email, required, helpers, requiredIf } from "@vuelidate/validators";
import { mapActions, mapState } from "pinia";
//@ts-ignore
import BaseInput from "./UIKitComponents/BaseInput";
//@ts-ignore
import BaseTextarea from "./UIKitComponents/BaseTextarea";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
import { MACROTYPOLOGY } from "@customTypes/MacrotypologyEnum";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import { replaceAllTokens } from "@utils/StringUtils";
import { defineAsyncComponent, defineComponent } from "vue";
import { useModalStore } from "@store/ModalStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { PHONE_REGEX } from "@utils/RegexUtils";
import { useValidator } from "@wkComposables/useValidator";
import { useMetadataStore } from "@wkWebSrc/js/store";
import { getOrNull } from "@utils/ObjectUtils";
var isChecked = function isChecked(value) {
  return value;
};
var phoneValidator = helpers.regex(PHONE_REGEX);
var requiredIfNotLogged = {
  required: requiredIf(function () {
    //@ts-ignore
    return !this.isUserLogged;
  })
};
export default defineComponent({
  name: "ContactAgencyBanner",
  components: {
    BaseInput: BaseInput,
    BaseTextarea: BaseTextarea,
    BaseButton: BaseButton,
    StaticSpinner: StaticSpinner,
    BaseAlert: BaseAlert,
    "contact-agency-success": defineAsyncComponent(function () {
      return import("./Modals/ContactAgencySuccess.vue");
    }),
    "limit-modal": defineAsyncComponent(function () {
      return import("./Modals/Status/LimitModal.vue");
    }),
    "limit-saved-modal": defineAsyncComponent(function () {
      return import("./Modals/Status/LimitSavedModal.vue");
    }),
    "unauthorized-modal": defineAsyncComponent(function () {
      return import("./Modals/Status/UnauthorizedModal.vue");
    })
  },
  props: {
    title: {
      type: String
    },
    icons: {
      type: Object,
      required: true
    },
    isUserLogged: {
      type: Boolean,
      "default": false
    },
    labels: {
      type: Object,
      required: true
    },
    labelTextarea: {
      type: String
    },
    valueTextarea: {
      type: String
    },
    agencyData: {
      type: Object,
      required: true
    },
    endedAuction: {
      type: Boolean,
      required: false,
      "default": false
    },
    // TODO: non è bello avere una proprietà publicUser in un componente per l'agency
    advertisingPublicUserID: {
      type: Number
    }
  },
  emits: ["open-login-modal"],
  setup: function setup() {
    var _useValidator = useValidator(),
      isValid = _useValidator.isValid;
    return {
      isValid: isValid,
      v$: useVuelidate()
    };
  },
  data: function data() {
    return {
      userInteraction: false,
      textareaMessage: "",
      name: "",
      email: "",
      phone: "",
      privacy: false,
      marketing: false,
      isTextAreaClicked: false,
      isSubmitting: false,
      isValidForm: false,
      responseContact: false,
      listingType: undefined,
      errorCode: -1,
      successModalData: null,
      successModalConfig: null,
      success: null,
      loginSuccess: false,
      show: false,
      errorMessage: ""
    };
  },
  validations: function validations() {
    return {
      name: Object.assign({}, requiredIfNotLogged),
      email: Object.assign(Object.assign({}, requiredIfNotLogged), {
        email: email
      }),
      phone: {
        phoneValidator: phoneValidator
      },
      textareaMessage: {
        required: required
      },
      privacy: {
        required: required,
        isChecked: isChecked
      }
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    readAndAcceptedByClicking: function readAndAcceptedByClicking() {
      var placeholder = "{0}";
      var tokens = this.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold\">").concat(replaceAllTokens(placeholder, {
        "{0}": this.endedAuction ? this.labels.send : this.labels.requestInfos
      }), "</span>").concat(tokens[1]);
    },
    privacy_C_section: function privacy_C_section() {
      return "".concat(this.labels.purpose, " C");
    },
    wikicasaUrl: function wikicasaUrl() {
      return window["wikicasaNewsURL"];
    },
    areInputsValid: function areInputsValid() {
      return !this.v$.name.$invalid && !this.v$.email.$invalid && !this.v$.phone.$invalid;
    },
    eventLocation: function eventLocation() {
      return "".concat(this.pageName, " - ").concat(this.location);
    }
  }, mapState(usePublicUserMenuStore, ["publicUserId"])), mapState(usePublicUserMenuStore, {
    loggedUserEmail: "email"
  })), mapState(useMetadataStore, ["pageName", "location"])),
  watch: {
    userInteraction: function userInteraction(cur) {
      var _a, _b, _c, _d, _e;
      if (!cur) return;
      sendGAEvent("specific_request_interaction", {
        event_location: this.eventLocation,
        agency_id: this.agencyData.agencyId,
        agency_name: getOrNull((_a = this.agencyData) === null || _a === void 0 ? void 0 : _a.agencyName),
        agency_place_id: null,
        agency_subscription_type: this.agencyData.premium ? "premium" : this.agencyData.lite ? "lite" : "free",
        agent_email: this.agencyData.agentEmail ? md5(this.agencyData.agentEmail) : null,
        agent_id: getOrNull(this.agencyData.agentId),
        agency_franchise_id: getOrNull(this.agencyData.franchiseId),
        agency_franchise_name: getOrNull(this.agencyData.franchiseName),
        product_price: this.agencyData.id ? parseFloat("".concat(this.agencyData.price).replace(".", "")) : null,
        real_estate_contract_type: ((_b = this.agencyData) === null || _b === void 0 ? void 0 : _b.rent) ? "rent" : "sale",
        real_estate_id: getOrNull((_c = this.agencyData) === null || _c === void 0 ? void 0 : _c.id),
        real_estate_place_id: getOrNull((_d = this.agencyData) === null || _d === void 0 ? void 0 : _d.placeID),
        real_estate_typology_name: getOrNull((_e = this.agencyData) === null || _e === void 0 ? void 0 : _e.typologyName),
        user_id: this.publicUserId == -1 ? null : this.publicUserId,
        user_email_hashed: md5(this.email || this.loggedUserEmail),
        user_email: this.email || this.loggedUserEmail,
        user_name: this.name,
        user_phone: getOrNull(this.phone)
      });
    }
  },
  created: function created() {
    var _a;
    this.setLocation("Banner contatta agenzia (step 1)");
    this.textareaMessage = (_a = this.valueTextarea) !== null && _a !== void 0 ? _a : "";
  },
  methods: Object.assign(Object.assign(Object.assign({
    submitForm: function submitForm() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isValid, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.isSubmitting = true;
              this.privacy = true;
              _context.prev = 2;
              _context.next = 5;
              return this.v$.$validate();
            case 5:
              isValid = _context.sent;
              if (isValid) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", false);
            case 8:
              _context.next = 10;
              return this.handleSendAgencyContact();
            case 10:
              _context.next = 18;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              response = _context.t0.response;
              if (response.status === 409) {
                sendGAEvent("specific_request_error_409", {
                  event_location: this.eventLocation
                });
                this.errorMessage = this.labels.requestErrorDuplicatedLabel;
              } else if (response.status != 409) {
                this.errorMessage = this.labels.requestErrorLabel;
              }
              this.responseContact = false;
            case 18:
              _context.prev = 18;
              this.isSubmitting = false;
              return _context.finish(18);
            case 21:
              return _context.abrupt("return", this.responseContact);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 12, 18, 21]]);
      }));
    },
    handleSendAgencyContact: function handleSendAgencyContact() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var contactsData, res, price, agencyWithId, data, modalConfig;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              contactsData = {
                agentId: this.agencyData.agentId,
                referenceId: this.agencyData.id || -1,
                canonicalURL: this.agencyData.canonicalURL,
                notes: this.textareaMessage
              };
              if (this.agencyData.agencyId == this.advertisingPublicUserID) contactsData["advertisingPublicUserId"] = this.advertisingPublicUserID;else contactsData["agencyId"] = this.agencyData.agencyId;
              if (!this.isUserLogged) {
                contactsData.name = this.name;
                contactsData.email = this.email;
                contactsData.phone = this.phone;
              }
              _context2.next = 5;
              return this.sendAgencyContact(contactsData);
            case 5:
              res = _context2.sent;
              if (res) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              price = null;
              agencyWithId = !!this.agencyData.id;
              if (agencyWithId) price = parseFloat("".concat(this.agencyData.price).replace(".", ""));
              data = this.agencyData;
              if (this.endedAuction) {
                sendGAEvent("auction_consultant_lead", {
                  event_location: "".concat(this.pageName, " - Banner asta scaduta"),
                  auction_consultant_id: (_a = this.agencyData) === null || _a === void 0 ? void 0 : _a.agencyId,
                  auction_consultant_name: getOrNull((_b = this.agencyData) === null || _b === void 0 ? void 0 : _b.agencyName),
                  real_estate_id: getOrNull((_c = this.agencyData) === null || _c === void 0 ? void 0 : _c.id),
                  real_estate_contract_type: "auction",
                  real_estate_place_id: getOrNull((_d = this.agencyData) === null || _d === void 0 ? void 0 : _d.placeID),
                  user_id: this.publicUserId == -1 ? null : this.publicUserId,
                  contract_type: "auction",
                  user_email_hashed: md5(this.email || this.loggedUserEmail),
                  user_email: this.email || this.loggedUserEmail
                });
              } else {
                if (!this.advertisingPublicUserID) sendGAEvent("specific_request_lead", {
                  event_location: this.eventLocation,
                  agency_id: this.agencyData.agencyId,
                  agency_name: getOrNull((_e = this.agencyData) === null || _e === void 0 ? void 0 : _e.agencyName),
                  agency_place_id: null,
                  agency_subscription_type: this.agencyData.premium ? "premium" : this.agencyData.lite ? "lite" : "free",
                  agent_email: data.agentEmail ? md5(data.agentEmail) : null,
                  agent_id: getOrNull(this.agencyData.agentId),
                  agency_franchise_id: getOrNull(this.agencyData.franchiseId),
                  agency_franchise_name: getOrNull(this.agencyData.franchiseName),
                  product_price: data.id ? price : null,
                  real_estate_contract_type: ((_f = this.agencyData) === null || _f === void 0 ? void 0 : _f.rent) ? "rent" : "sale",
                  real_estate_id: getOrNull((_g = this.agencyData) === null || _g === void 0 ? void 0 : _g.id),
                  real_estate_place_id: getOrNull((_h = this.agencyData) === null || _h === void 0 ? void 0 : _h.placeID),
                  real_estate_typology_name: getOrNull((_j = this.agencyData) === null || _j === void 0 ? void 0 : _j.typologyName),
                  user_id: this.publicUserId == -1 ? null : this.publicUserId,
                  user_email_hashed: md5(this.email || this.loggedUserEmail),
                  user_email: this.email || this.loggedUserEmail,
                  user_name: this.name,
                  user_phone: this.phone
                });else sendGAEvent("specific_request_lead", {
                  event_location: this.eventLocation,
                  advertisingPublicUserID: this.advertisingPublicUserID,
                  agency_name: null,
                  agency_place_id: null,
                  agency_subscription_type: "free",
                  agent_email: null,
                  agent_id: null,
                  agency_franchise_id: null,
                  agency_franchise_name: null,
                  product_price: data.id ? price : null,
                  real_estate_contract_type: ((_k = this.agencyData) === null || _k === void 0 ? void 0 : _k.rent) ? "rent" : "sale",
                  real_estate_id: getOrNull((_l = this.agencyData) === null || _l === void 0 ? void 0 : _l.id),
                  real_estate_place_id: getOrNull((_m = this.agencyData) === null || _m === void 0 ? void 0 : _m.placeID),
                  real_estate_typology_name: getOrNull((_o = this.agencyData) === null || _o === void 0 ? void 0 : _o.typologyName),
                  user_id: this.publicUserId == -1 ? null : this.publicUserId,
                  user_email_hashed: md5(this.email || this.loggedUserEmail),
                  user_email: this.email || this.loggedUserEmail,
                  user_name: this.name,
                  user_phone: this.phone
                });
              }
              modalConfig = {
                showSaveSearch: true,
                showGenericRequest: false
              };
              if (agencyWithId && (data.macroTypology != MACROTYPOLOGY.BUSINESS || ((_p = this.listingType) === null || _p === void 0 ? void 0 : _p.includes(this.agencyData.typology))) && data.macroTypology != MACROTYPOLOGY.ACTIVITY) modalConfig.showGenericRequest = true;else modalConfig.showSaveSearch = false;
              this.successModalData = Object.assign(Object.assign({}, data), contactsData);
              this.successModalConfig = modalConfig;
              this.show = true;
              //Opening the success modal! // TODO: deprecate?
              this.success = true;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    },
    openPrivacyDisclaimer: function openPrivacyDisclaimer() {
      window.open("/privacy", "_blank", "scrollbars=yes, width=550, height=600");
    },
    handleShowErrorModal: function handleShowErrorModal(errorCode) {
      this.errorCode = errorCode;
    },
    openSigninModal: function openSigninModal() {
      this.show = false;
      this.setShowModal(Modals.signInModal);
    },
    openLoginModal: function openLoginModal() {
      this.show = false;
      this.$emit("open-login-modal");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(usePublicUserMenuStore, ["sendAgencyContact"])), mapActions(useMetadataStore, ["setLocation"]))
});